import axiosInstance from "../utils/ApiUtils/axiosInstance";

export const reTranslateTranslation = async (translationId: number): Promise<number | null> => {
  const response = await axiosInstance.post<ApiResponse<number>>(`/api/translation/re-translate-translation`, {
    translationId,
  });
  return response.data.data;
};
